import { Lightning } from '@lightningjs/sdk';
import { DEFAULT_MODE } from '@tornado-rdk/theme';
import { identity } from '../utils/sizes';
import { colors, HEIGHT } from './progress.style';
import { safeProgressValue } from './progress.utils';
import { FULLY_SHOWN_PERCENTAGE } from './progress.constants';

export default class Progress extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      color: colors.background[DEFAULT_MODE],
      h: HEIGHT,
      Bar: {
        rect: true,
        color: colors.bar[DEFAULT_MODE],
        h: identity,
      },
    };
  }

  _construct() {
    this._progress = 0;
  }

  _handleProgressUpdate(w) {
    const width = w || this.finalW || this.w;
    const progressWidth = this._progress > FULLY_SHOWN_PERCENTAGE ? width : width * this._progress;

    this.tag('Bar').w = progressWidth;
  }

  get w() {
    return super.w;
  }

  set w(value) {
    super.w = value;
    this._handleProgressUpdate(Number.isFinite(value) ? value : null);
  }

  get progress() {
    return this._progress;
  }

  set progress(value) {
    this._progress = safeProgressValue(value);
    this._handleProgressUpdate();
  }

  get colorMode() {
    return this._colorMode;
  }

  set colorMode(value) {
    this._colorMode = value;

    this.patch({
      color: colors.background[this._colorMode],
      Bar: {
        color: colors.bar[this._colorMode],
      },
    });
  }
}
